import { render, staticRenderFns } from "./ActiveArticle.vue?vue&type=template&id=2cac5cd2&"
import script from "./ActiveArticle.vue?vue&type=script&lang=js&"
export * from "./ActiveArticle.vue?vue&type=script&lang=js&"
import style0 from "./ActiveArticle.vue?vue&type=style&index=0&id=2cac5cd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports